export {
  ReportTableComponent
} from "./report-table/report-table.component";
